<template>
  <div class="menu">
    <template v-for="item in routes">
      <!-- <router-link v-if="!item.hidden&&item.children&&item.children.length===1&&item.path==''" :to="item.children[0].path" :key="item.children[0].name">
        <el-menu-item :index="item.children[0].path" class="submenu-title-noDropdown">
          <i v-if="item.children[0].meta&&item.children[0].meta.icon" :class="item.children[0].meta.icon"></i>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" >{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link> -->
      <el-submenu  v-if="!item.hidden&&item.children" :index="item.name" :key="item.name">
        <template slot="title">
          <i v-if="item.meta&&item.meta.icon" :class="item.meta.icon"></i>
          <span v-if="item.meta&&item.meta.title">{{item.meta.title}}</span>
        </template>
        <template v-for="child in item.children">  
            <menu-list v-if="!child.hidden&&child.children&&child.children.length" :routes="[child]" :key="child.name" ></menu-list>
            <router-link v-else-if="!child.hidden" :to="child.path" :key="child.name">
              <el-menu-item :index="child.path">
                <i v-if="child.meta&&child.meta.icon" :class="child.meta.icon"></i>
                <span v-if="child.meta&&child.meta.title">{{child.meta.title}}</span>
              </el-menu-item>
            </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "menuList",
  props: {
    routes: {
      type: Array
    }
  },
  data() {
    return {
      routeslist: null,
      limitInfo: [],
      rootArray: []
    };
  },
  mounted() {
    this.routeslist = this.routes;
  }
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// menuList.vue?21c250da